module.exports = "https://static.wmbcdn.com/uniweb/images/60862bf8e3ff76c33979187ae0eefa01.svg";